import { render, staticRenderFns } from "./WebPagesButtonForm.vue?vue&type=template&id=6d3f56e4&"
import script from "./WebPagesButtonForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesButtonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports